import { render } from "./App.vue?vue&type=template&id=c5090142&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=c5090142&lang=css"

import exportComponent from "/Users/rico/_repos/99v/trackyourgame/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__